import { useRef, useState } from 'react';
import { message } from 'antd';
import { leadService } from '../services';
import '../styles/home.css';

const ContactMessageForm = ({ title = 'İletişim Formu', className = '' }) => {
  const [submitting, setSubmitting] = useState(false);
  const submitLock = useRef(false);
  const formRef = useRef(null);

  const handleSubmit = async () => {
    if (submitLock.current || submitting) {
      return;
    }

    const formElement = formRef.current;
    if (!formElement) {
      return;
    }

    if (!formElement.reportValidity()) {
      return;
    }

    const formData = new FormData(formElement);
    const payload = {
      name: String(formData.get('name') || '').trim(),
      email: String(formData.get('email') || '').trim(),
      phone: String(formData.get('phone') || '').trim(),
      subject: String(formData.get('subject') || '').trim(),
      message: String(formData.get('message') || '').trim(),
    };

    if (!payload.name || !payload.email || !payload.phone || !payload.subject || !payload.message) {
      message.warning('Lütfen tüm alanları doldurun.');
      return;
    }

    submitLock.current = true;
    setSubmitting(true);
    message.destroy('contact-submit');

    try {
      await leadService.submitContactMessage(payload);
      message.success({
        key: 'contact-submit',
        content: 'Mesajınız alındı. Ekibimiz en kısa sürede dönüş yapacak.',
      });
      formElement.reset();
    } catch (error) {
      const errorData = error.response?.data;
      const firstFieldError = errorData && typeof errorData === 'object'
        ? Object.values(errorData).flat().find(Boolean)
        : null;

      message.error({
        key: 'contact-submit',
        content: errorData?.detail || firstFieldError || 'Mesaj gönderilemedi.',
      });
    } finally {
      submitLock.current = false;
      setSubmitting(false);
    }
  };

  return (
    <form
      ref={formRef}
      className={`lead-capture-form ${className}`.trim()}
      onSubmit={(event) => event.preventDefault()}
    >
      <h3>{title}</h3>

      <label htmlFor="contact-name">Ad Soyad</label>
      <input id="contact-name" name="name" type="text" placeholder="Adınız ve soyadınız" required />

      <label htmlFor="contact-email">E-posta</label>
      <input id="contact-email" name="email" type="email" placeholder="ornek@mail.com" required />

      <label htmlFor="contact-phone">Telefon</label>
      <input id="contact-phone" name="phone" type="tel" placeholder="05xx xxx xx xx" required />

      <label htmlFor="contact-subject">Konu</label>
      <input id="contact-subject" name="subject" type="text" placeholder="Görüşmek istediğiniz konu" required />

      <label htmlFor="contact-message">Mesajınız</label>
      <textarea id="contact-message" name="message" rows="5" placeholder="Mesajınızı buraya yazın" required />

      <button type="button" onClick={handleSubmit} disabled={submitting}>
        {submitting ? 'GÖNDERİLİYOR...' : 'GÖNDER'}
      </button>
    </form>
  );
};

export default ContactMessageForm;